<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4 transition-opacity duration-300 ease-out opacity-100 animate-fadeIn"
  (click)="closePopup()"
>
  <div
    class="bg-white dark:bg-[#1E1E48] border border-transparent dark:border-[#E9E9E9] flex flex-col gap-4 rounded-2xl shadow-lg w-[500px] px-6 py-8 text-center"
    (click)="$event.stopPropagation()"
  >
    <div class="flex justify-center">
      <img src="icons/logout-icon.svg" alt="warning" />
    </div>

    <h2 class="text-2xl font-medium text-secondary dark:text-[#F2F2F2]">
      {{ "Profile.LogOut" | translate }}
    </h2>

    <p class="text-muted font-medium dark:text-[#ce8787]">
      {{ "Profile.Logout_Message" | translate }}
    </p>

    <div class="flex gap-3 justify-center">
      <button
        (click)="closePopup()"
        class="bg-transparent font-medium border border-secondary text-secondary rounded-md text-sm sm:text-base px-4 py-2 w-1/2"
      >
        {{ "Shared.Cancel" | translate }}
      </button>

      <button
        (click)="logout()"
        class="rounded-md text-sm sm:text-base px-4 py-2 w-1/2 bg-secondary text-white"
      >
        {{ "Profile.Log_Me_Out" | translate }}
      </button>
    </div>
  </div>
</div>
